import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Ettepanekud

  <span style="color:#85c1dc;">**FI:**</span>
  Ehdotuksia.

  <span style="color:#85c1dc;">**RU:**</span>
  Предложения
*/
/* @__NO_SIDE_EFFECTS__ */
const m963 = msg(
  mf`Ettepanekud`,
  mf`Ehdotuksia.`,
  mf`Предложения`,
)

export { m963 as 'w.module.no-results.search.suggestions.title' }